import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";

export function initSpacesSlider() {
  const swiper = document.querySelector(".explore-spaces__swiper");

  new Swiper(swiper, {
    modules: [Navigation, Pagination],
    slidesPerView: 1.2,
    spaceBetween: 15,
    speed: 800,
    navigation: {
      prevEl: ".explore-spaces__btn-prev",
      nextEl: ".explore-spaces__btn-next",
    },
    breakpoints: {
      700: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1100: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
}
